import { useParams } from 'react-router';
import { useFlowsSelector } from '../../../common/src/utils/globalVariables';

const useCurrentGroupPosition = (): number => {
  const lastPosition = useFlowsSelector(
    (state) => state.flowsMetaData.lastPosition,
  );
  const { position } = useParams<{ position: string }>();

  const currentPosition = isNaN(Number(position))
    ? lastPosition
    : Number(position);

  return currentPosition;
};
export default useCurrentGroupPosition;
